@if (seccionActive) {
  <div class="iframe-container">
    <iframe
      id="traccarIframe"
      [src]="urlTraccar"
      frameborder="0"
      allow="same-origin"
      (load)="onIframeLoad($event)"
    ></iframe>
  </div>
}